module.exports = __webpack_public_path__ + "img/history_icon.d15e7835.svg";